import useStorageEvent from '@/hooks/useStorageEvent';
import { getPermissions } from '@/utils/authority';
import isEqual from 'lodash/isEqual';
import sortBy from 'lodash/sortBy';
import { useState } from 'react';

export const usePermissions = () => {
  const [permissions, setPermissions] = useState(getPermissions() ?? []);

  useStorageEvent('permissions', () => {
    setPermissions((oldPermissions) => {
      const newPermissions = getPermissions() ?? [];
      if (isEqual(sortBy(oldPermissions), sortBy(newPermissions))) {
        return oldPermissions;
      }
      return newPermissions;
    });
  });

  return { permissions };
};
